
import React from "react";
import { FieldTableColumnProps } from "../../components/FieldTable/FieldTableTypes";
import { Link } from 'react-router-dom';
import { Role, RolesQueryDocument, useRolesMutationMutation} from "../../generated/graphql";
import {SideList} from "../../components/SideList";

const columns: FieldTableColumnProps<Role>[] = [
  {
    header: 'Name',
    accessor: 'name',
    dataType:'link',
    options: {
      getLink: ({field,row})=> {
        return ({
          pathname: '/settings/roles/' + row.id,
          search: (location.search ? location.search : '')
        });
      }
/*      renderViewer:({field,row})=> {
        if(field.raw) return field.value;
        return (<Link to={{
          pathname: '/settings/roles/' + row.id,
          search: (location.search ? location.search : '')
        }}>{field.value}</Link>)
      }*/
    }
  }
];


const Roles = () => {

    const deleteMutation = useRolesMutationMutation();
    return <SideList
        searchForm={null}
        label="Roles"
        className="roles"
        permission="roles"
        deleteMutation={deleteMutation}
        query={RolesQueryDocument}
        columns={columns}
        baseUrl="/settings/roles/"
        mode={null}
        noEditorScroll={null}
    />;


};

export default Roles;